import React, { useEffect, useState } from 'react';
import { LoadingIndicator } from '../../../../lib/components';
import { BsPlus } from 'react-icons/bs';
import { QRVideo } from '../../../../lib/api';
import { ModalAddOrEditQrCodes } from '../../../../lib/components/modal/ModalAddOrEditQrCodes';
import { QRCodesTable } from './components/QRCodesTable';
import { deleteQRVideo } from '../../../../lib/api/qrVideosApi';
import { Heading } from 'lib/components/styles/typography';
import { HeaderWrapper, MainWrapper } from 'lib/components/styles/layout';
import { Button } from 'react-covideo-common';
import selectors from '../../../../cypress/selectors';
import { successToast } from 'lib/components/toasts/success';
import { errorToast } from 'lib/components/toasts/error';
import { useQrVideosQuery } from 'lib/api/qrVideos/useQrVideosQuery';
import { useTranslation } from 'react-i18next';

interface ModalWithData {
  toOpen: 'add' | 'edit' | 'delete' | 'none';
  data?: QRVideo;
}

const QrCodes = () => {
  const { t } = useTranslation();
  const [modalWithData, setModalWithData] = useState<ModalWithData>({
    toOpen: 'none',
  });
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(10);

  const {
    data,
    refetch,
    isLoading: loading,
  } = useQrVideosQuery({
    params: {
      page,
      size,
      sort: '-',
    },
  });

  const onCloseModal = () => {
    setModalWithData({ toOpen: 'none', data: undefined });
    refetch();
  };

  const onDelete = async (qrVideo: any) => {
    try {
      await deleteQRVideo(qrVideo);
      successToast({ title: t('QR Code deleted successfully') });
    } catch (e) {
      errorToast({ title: t('Error deleting QR Code') });
    }
    refetch();
  };

  const onEdit = async (qrVideo: any) => {
    setModalWithData({ toOpen: 'edit', data: qrVideo });
  };

  useEffect(() => {
    refetch();
  }, [page, size]);

  const onPaginationChange = async ({ page: newPage, size: newSize }: any) => {
    if (page !== newPage || size !== newSize) {
      setPage(newPage);
      setSize(newSize);
    }
  };

  return (
    <MainWrapper resetPadding={false}>
      {modalWithData.toOpen === 'add' && (
        <ModalAddOrEditQrCodes
          type={modalWithData.toOpen}
          onClose={onCloseModal}
        />
      )}
      {modalWithData.toOpen === 'edit' && modalWithData.data && (
        <ModalAddOrEditQrCodes
          data={modalWithData.data}
          type={modalWithData.toOpen}
          onClose={onCloseModal}
        />
      )}
      <HeaderWrapper>
        <Heading>{t('QR Codes')}</Heading>
        <Button
          text={t('New QR Code')}
          icon={<BsPlus />}
          onClick={() => setModalWithData({ toOpen: 'add' })}
          data-cy={selectors.qrCodePage.new}
        />
      </HeaderWrapper>

      {loading && <LoadingIndicator isLoading={true} height='300px' />}
      {!loading && (
        <>
          {!data?.qrVideos?.length ? (
            <p
              style={{
                fontWeight: 'bold',
                textAlign: 'center',
                margin: '36px 0',
              }}
            >
              {t('No matching results found.')}
            </p>
          ) : (
            <QRCodesTable
              data={data}
              onDelete={onDelete}
              onEdit={onEdit}
              onPaginationChange={onPaginationChange}
              page={page}
              size={size}
            />
          )}
        </>
      )}
    </MainWrapper>
  );
};
export default QrCodes;
